import styled from 'vue3-styled-components';

export const AsPopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 60vh;
  overflow: hidden;
`;

export const TableContainer = styled.div`
  overflow-y: auto;
  max-height: 50vh;
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const AsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const AsTh = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  background-color: #f2f2f2;
  font-size: 16px;
`;

export const AsTd = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  font-size: 16px;
`;

export const AsDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  margin-top: 15px;
`;

export const AsRequest = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const AsLabel = styled.label`
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 20px;
  text-align: left;
  align-items: left;

  &::before {
    content: '● ';
    margin-right: 5px;
    font-size: 18px;
    vertical-align: 1px;
  }
`;

export const AsTextarea = styled.textarea`
  resize: vertical;
  font-size: 16px;
  margin-top: 10px;
  padding: 10px;
`;

export const AsInput = styled.input`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  font-size: 16px;
  height: 25px;
  width: 25%;
`;

export const AsCheckbox = styled('input')`
  width: 20px;
  height: 20px;
  cursor: pointer;
  
  &:checked {
    accent-color: #2196F3;
  }
  
  &:hover {
    opacity: 0.8;
  }
`;

export const AsButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 20px;
`;